/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== ''
    )
  ).toString();

class DealAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(`${this.url}?${buildParams(params)}`);
  }

  move(id, pipelineStageId, index) {
    return axios.patch(`${this.url}/${id}/move`, {
      pipeline_stage_id: pipelineStageId,
      index,
    });
  }

  listConversations(id) {
    return axios.get(`${this.url}/${id}/conversations`);
  }

  linkConversation(id, conversationId) {
    return axios.post(`${this.url}/${id}/conversations`, {
      conversation_id: conversationId,
    });
  }

  unlinkConversation(id, conversationId) {
    return axios.delete(`${this.url}/${id}/conversations/${conversationId}`);
  }
}

export default new DealAPI();
